import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "log",
  "use": "log-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"log\"><g fill-rule=\"evenodd\"><path d=\"M14 14.5a.5.5 0 01-.5.5h-12a.5.5 0 01-.5-.5V4h13v10.5zM13.5 2H13V0h-2v2H4V0H2v2h-.5C.673 2 0 2.673 0 3.5v11c0 .827.673 1.5 1.5 1.5h12c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5z\" /><path d=\"M2 9h5V5H2zM8 9h5V5H8zM2 14h5v-4H2zM8 14h5v-4H8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id